// LanguageSwitcher.js
import React from 'react';
import { useIntl } from 'react-intl';

function LanguageSwitcher() {
  const intl = useIntl();

  const changeLanguage = (locale) => {
    intl.locale = locale;
    console.log(locale);
  };

  return (
    <div>
      <button onClick={() => changeLanguage('en')}>
       EN
      </button>
      <button onClick={() => changeLanguage('pt-PT')}>
        PT
      </button>
    </div>
  );
}

export default LanguageSwitcher;
